const tenant_name = 'nimble';

export const apiUrl = `https://uat-m-api.souqbox.io/api/v1/channel-partner`;
export const defaultPagination = 20;
export const perPageList =  [20, 50, 100];
export const is_live = false;

export const APP_NAME = 'imann';
export const APP_PORTAL = 'partner';
export const APP_TENANT = tenant_name;
export const APP_LEVEL_2_URL = "uat-m.souqbox.io"
export const APP_DEMO_TENANT_AUTH_PAGE = "/pages/demo-portal-redirect?code="
export const APP_PUSHER_KEY = "fa8c035e0345547d6584"

export const baseUri = window.location.host
export const GoCardLessRedirectUri = 'http://localhost:8080/pages/tenants'
export const GoCardLessExitUri = 'http://localhost:8080/pages/tenants'

